import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "../../../../utils";
import RoutesMap from "../../../../route_control/RouteControl"

export const companyDetailsTodo = createAsyncThunk('companyDetails', async ({ id, navigate }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: getConfig.API_URL + `company/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const companyDetailsSlice = createSlice({
    name: 'companyDetails',
    initialState: {
        data: '',
    },
    extraReducers: (builder) => {
        builder.addCase(companyDetailsTodo.fulfilled, (state, action) => {
            if (action?.payload?.status == 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status == 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status == 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = ''
            }

        });
        builder.addCase(companyDetailsTodo.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default companyDetailsSlice.reducer;
